
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFire as ObiFireElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fire.js';
 
 
 

 
 export const ObiFire = createComponent({
   react: React,
   tagName: 'obi-fire',
   elementClass: ObiFireElement,
   events: {
     
   }
  });
 
 